/** Safely parse a JSON string, returning fallback on failure.
 *  Handles Supabase returning Postgres text[] as native JS arrays. */
export function tryParseJSON<T>(value: string | T | null | undefined, fallback: T): T {
  if (value == null) return fallback;
  if (typeof value !== "string") return value as T;
  if (value === "") return fallback;
  try { return JSON.parse(value); } catch { return fallback; }
}
